"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssociateAction = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ActionModal = require("../ActionModal.styles");

var _InsightSummary = require("./components/InsightSummary");

var _ActionList = require("./components/ActionList");

var _ActionDetail = require("../ViewAction/components/ActionDetail");

var _LoadingOverlay = require("../components/LoadingOverlay");

var _associate = require("../../../redux/modules/_BETA/associate");

var _context = require("./context");

var _useActions = require("./context/useActions");

var _types = require("./context/types");

var _actionField = require("../../../context/actionField");

var _attachments = require("../../../context/attachments");

const ContentWrapper = _styledComponents.default.section`
  display: flex;
  flex-direction: row;

  width: 860px;
  position: relative;
`;
const LeftColumn = _styledComponents.default.div`
  flex-basis: 50%;
  max-width: 50%;

  position: relative;
  border-right: 1px solid ${_blocks.palette.neutral3};
`;
const RightColumn = _styledComponents.default.div`
  flex-basis: 50%;
  max-width: 50%;
  height: 454px;
  overflow: auto;
  background-color: ${_blocks.palette.neutral1};

  @media (min-height: 800px) {
    height: 654px;
  }
`;
const NoAction = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${_blocks.typography.displaySmall};
  color: ${_blocks.color.theme.typography.subdued};
`;
const ErrorMessage = (0, _styledComponents.default)(_blocks.BodyLarge)`
  font-weight: ${_blocks.fontWeight.bold};
  padding: ${_blocks.spacing.loose};
  text-align: center;
`;

function mapStateToProps(state) {
  return {
    isAssociating: state.betaAssociate.isAssociating,
    complete: state.betaAssociate.complete,
    // complete association
    userSites: state.userSites
  };
}

const mapDispatchToProps = {
  linkEquipRulesToTicket: (equipRuleIds = [], issueKey) => (0, _associate.associateEquipRule)({
    equipRuleIds,
    issueKey
  })
};

const AssociateAction = ({
  ruleName,
  syncoId,
  hits,
  userSites,
  isAssociating,
  complete,
  linkEquipRulesToTicket
}) => {
  const site = userSites.sites[syncoId];
  const project = userSites.projects[site.projectId];
  const {
    actions,
    selectedAction,
    equipRuleIds,
    error,
    modalStatus,
    listStatus
  } = (0, _context.useState)();
  const {
    hideModal,
    loadActions,
    selectAction,
    updateAction
  } = (0, _useActions.useActions)();
  const equipNames = equipRuleIds !== undefined ? equipRuleIds.map(equipRuleId => {
    const hit = hits.find(h => h.equipRuleId === equipRuleId);
    return hit.targetName;
  }) : undefined;
  React.useEffect(() => {
    if (site && project && modalStatus === _types.ModalStatus.open) {
      void loadActions(site.id, project.jira_key);
    }
  }, [site, project, modalStatus]);
  React.useEffect(() => {
    if (!isAssociating && complete) {
      hideModal();
    }
  }, [isAssociating, complete]);

  const onSelect = action => {
    selectAction(action);
  };

  const handleAssociateToIssue = () => {
    if (selectedAction !== undefined && equipRuleIds !== undefined) {
      linkEquipRulesToTicket(equipRuleIds, selectedAction.key);
    }
  };

  return /*#__PURE__*/React.createElement(_ActionModal.Modal, {
    title: "Associate Insight With Action",
    isOpen: modalStatus === _types.ModalStatus.open,
    onRequestClose: () => hideModal()
  }, /*#__PURE__*/React.createElement(_blocks.ModalContent, null, /*#__PURE__*/React.createElement(ContentWrapper, null, listStatus === _types.Status.loading && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, null), /*#__PURE__*/React.createElement(LeftColumn, null, equipNames !== undefined && /*#__PURE__*/React.createElement(_InsightSummary.InsightSummary, {
    ruleName: ruleName,
    equipNames: equipNames
  }), listStatus === _types.Status.error && /*#__PURE__*/React.createElement(ErrorMessage, null, error), listStatus === _types.Status.ready && /*#__PURE__*/React.createElement(_ActionList.ActionList, {
    actions: actions,
    selectedAction: selectedAction,
    onSelect: onSelect
  })), /*#__PURE__*/React.createElement(RightColumn, null, selectedAction === undefined ? /*#__PURE__*/React.createElement(NoAction, null, "No Action Selected") : /*#__PURE__*/React.createElement(_attachments.AttachmentsProvider, null, /*#__PURE__*/React.createElement(_actionField.ActionFieldProvider, null, /*#__PURE__*/React.createElement(_ActionDetail.ActionDetail, {
    withInModal: true,
    action: selectedAction,
    onActionChange: updateAction
  })))))), /*#__PURE__*/React.createElement(_blocks.ModalFooter, null, /*#__PURE__*/React.createElement(_blocks.ControlGroup, {
    extraTight: true
  }, /*#__PURE__*/React.createElement(_blocks.Button, {
    appearance: "plain",
    onClick: () => hideModal()
  }, "Cancel"), /*#__PURE__*/React.createElement(_blocks.Button, {
    primary: true,
    disabled: selectedAction === undefined || isAssociating,
    onClick: handleAssociateToIssue
  }, "Associate"))));
};

const ConnectedAssociateAction = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssociateAction);
exports.AssociateAction = ConnectedAssociateAction;